export default {
  async updateInputFilledCountList({ commit }, payload) {
    commit("SET_INPUT_FILLED_COUNT_LIST", payload);
  },
  async clearInputFilledCountList({ commit }) {
    commit("SET_INPUT_FILLED_COUNT_LIST", null);
  },
};
